export default "__VITE_ASSET__tI6uiGNF__"